import { Component } from '@angular/core';
import { ActionType, PersonNotificationDto } from '@nx-ratenow/shared/models';
import { Observable, Subject } from 'rxjs';
import { NotificationsFacade } from '../../+state/notifications/notifications.facade';

@Component({
  standalone: false,
  selector: 'nx-ratenow-toolbar-notifications-dropdown',
  templateUrl: './toolbar-notifications-dropdown.component.html',
  styleUrls: ['./toolbar-notifications-dropdown.component.scss']
})
export class ToolbarNotificationsDropdownComponent {
  notificationList$: Observable<PersonNotificationDto[]> = this.notificationsFacade.notifications$;
  notificationScheduledList$: Observable<PersonNotificationDto[]> = this.notificationsFacade.scheduled$;

  enumActionType = ActionType;

  ngUnsubscribe$: Subject<ToolbarNotificationsDropdownComponent> = new Subject();

  constructor(private notificationsFacade: NotificationsFacade) {}

  sendAction(action: ActionType, notification: PersonNotificationDto) {
    this.notificationsFacade.sendAction(action, notification);
  }
}
